import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Geek at a music festival: Day 2",
  "description": "",
  "published": "2012-07-13T00:00:00.000Z",
  "redirect_from": ["/blog/geek-at-a-music-festival-day-2/swizec/4830"],
  "categories": "Arcade game, Coin-Op, Dinar, fun, Rakia, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I discovered a fatal flaw in my plans for all night partying and merry making - I don't sleep. Got back from the festival at 5am. Woke up 5 hours later ... simply because I didn't do a lot of braining the previous day and that was enough.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo1-e1342179158689-764x1024.jpg",
        "alt": "Arcade - the funnest thing at EXIT",
        "title": "Arcade - the funnest thing at EXIT"
      }}></img></p>
    <p>{`So much for `}<em parentName="p">{`"Oh yeah, you're gonna party all night and sleep all day"`}</em>{` Nope, not for me. I'm going to walk around all day and do stuff, then become insanely sleepy and tired at 3am and have to go home because trying to party when you're half asleep just isn't all that fun.`}</p>
    <p>{`But I have to say the general festival experience is pretty awesome! I never expected I could have this much fun cramped together in a party, with no elbow room to speak of and trying to dance my feet off to some strange music. Although I can hardly call Gossip strange music since I almost sort of recognised almost a third of the songs.`}</p>
    <p>{`And I count that as a great success.`}</p>
    <p>{`By the way, EXIT doesn't serve any proper drinks so I have been reduced to the savage state of subsisting on beer, hot dogs and energy drinks. The dark beer is almost palatable, but it gets the job done.`}</p>
    <p>{`The highlight of the evening was of course the arcade.`}</p>
    <p><a parentName="p" {...{
        "href": "http://twitter.com/robertbasic"
      }}>{`@robertbasic`}</a>{` and I found this old style arcade that's set up to have infinite coins. When you die, you just press continue and it goes on forever and ever in spite of your skill! Hooray! Really amazing stuff, I think we played for at least an hour ... no idea what the game was, don't even know what it was called or how to play it.`}</p>
    <p>{`Pure fun.`}</p>
    <p>{`Yes, yes that was much more fun than the time I suddenly found myself entertaining a group of four or five girls and sort of dancing with them in one large pile of sexy bodies. Yes, even more fun than paying 200 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Dinar",
        "title": "Dinar"
      }}>{`dinars`}</a>{` for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Rakia",
        "title": "Rakia"
      }}>{`rakia`}</a>{` and getting 300 dinars back because of reasons.`}</p>
    <p>{`Yep, they sell rakia in small tubes on the way up to the fortress.`}</p>
    <p>{`Oh and it was `}<em parentName="p">{`definitely`}</em>{` more fun than losing the rageface badge I bought with the 100 dinars I earned by buying rakia.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-2-e1342179272780-764x1024.jpg",
        "alt": "Badges!",
        "title": "Badges!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-11-e1342179362322-1024x764.jpg",
        "alt": "Clock tower with inverted hands",
        "title": "Clock tower with inverted hands"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-3-1024x764.jpg",
        "alt": "Gossip on the main stage",
        "title": "Gossip on the main stage"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100106846_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}>{`Geek at a music festival: Day 1`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.howtogeek.com/118622/how-to-play-classic-arcade-games-on-your-pc/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/99685103_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.howtogeek.com/118622/how-to-play-classic-arcade-games-on-your-pc/"
        }}>{`How to Play Classic Arcade Games On Your PC`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://business.financialpost.com/2012/07/12/take-advantage-of-renaissance-for-geeks-startup-festival-goers-told/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100198806_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://business.financialpost.com/2012/07/12/take-advantage-of-renaissance-for-geeks-startup-festival-goers-told/"
        }}>{`Take advantage of 'Renaissance for geeks', Startup Festival goers told`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://geeksyndicate.wordpress.com/2012/06/22/age-of-the-geek-comes-to-the-edinburgh-fringe-festival/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95840541_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://geeksyndicate.wordpress.com/2012/06/22/age-of-the-geek-comes-to-the-edinburgh-fringe-festival/"
        }}>{`'Age of the Geek' Comes to the Edinburgh Fringe Festival`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a2004f09-c557-4528-9407-34bd177f01f0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      